import React from 'react'

const ProcessIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="currentColor"
      className={className}
      style={{ display: 'block' }}
    >
      {/* Inner Gear/Process Segments */}
      <path d="M34.8,22.11a10.33,10.33,0,0,0-6.16,0l.92-7.93h4.33Z" />
      <path d="M48.38,25.34l-6.52,4.6a10.21,10.21,0,0,0-3-5.41l7.41-3Z" />
      <path d="M47.89,39.77,45.55,43.4l-7.19-3.51A10.2,10.2,0,0,0,41.7,34.7Z" />
      <path d="M34.12,42,32.65,49.9l-4.31-.31-.38-8a10.18,10.18,0,0,0,3.76.71A9.92,9.92,0,0,0,34.12,42Z" />
      <path d="M24.06,38.91l-7.61,2.48-1.81-3.94,6.83-4.15A10.17,10.17,0,0,0,24.06,38.91Z" />

      {/* Central Rotating Element */}
      <path d="M31.72,44.32A12.36,12.36,0,0,1,19.48,33.55a12.2,12.2,0,0,1-.1-1.57,11.86,11.86,0,0,1,.7-4.08,12.32,12.32,0,0,1,20.19-4.81,12.12,12.12,0,0,1,3.55,6.47A11.75,11.75,0,0,1,44.06,32a12.27,12.27,0,0,1-4.42,9.46A12.09,12.09,0,0,1,34.57,44,11.65,11.65,0,0,1,31.72,44.32Zm0-20.68a8.35,8.35,0,0,0-2.49.38,8.16,8.16,0,0,0-2.43,1.22,8.43,8.43,0,0,0-3,4A8.29,8.29,0,0,0,23.38,32a6.41,6.41,0,0,0,.07,1,8.21,8.21,0,0,0,2.09,4.56,8,8,0,0,0,3.14,2.17,8.21,8.21,0,0,0,5,.35,7.88,7.88,0,0,0,3.41-1.72,8.23,8.23,0,0,0,2.71-4.19,8.57,8.57,0,0,0,.29-2.2,7.77,7.77,0,0,0-.16-1.63A8.23,8.23,0,0,0,37.51,26a8.37,8.37,0,0,0-3.31-2A8.56,8.56,0,0,0,31.72,23.64Z" />

      {/* Remaining Structure Paths */}
      <path d="M25.63,23.62A10.39,10.39,0,0,0,22,28.57L16.13,23.1l2.58-3.47Z" />
      <path d="M10.33,22.89,6.65,21.32A27.28,27.28,0,0,1,53.76,16l.54-1.64,3.8,1.24-1.88,5.77a2,2,0,0,1-3.69.28,23.27,23.27,0,0,0-42.2,1.26Z" />
      <rect
        x="49.35"
        y="17.47"
        width="4"
        height="5.96"
        transform="translate(26.23 69.69) rotate(-84.69)"
      />
      <path d="M32.28,59.22a27.11,27.11,0,0,1-22-11.2L9.7,49.66,5.9,48.42l1.88-5.77a2,2,0,0,1,3.69-.28,23.27,23.27,0,0,0,42.2-1.26l3.68,1.57A27.23,27.23,0,0,1,32.28,59.22Z" />
      <rect
        x="10.65"
        y="40.56"
        width="4"
        height="5.96"
        transform="translate(-31.88 52.11) rotate(-84.69)"
      />
    </svg>
  )
}

export default ProcessIcon
